module.exports = __webpack_public_path__ + "img/eras-logo.401fda8d.png";